import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

// TODO(intools-access): replace placeholder ids with real backend-provisioned 32-hex (T002).
export const IntoolsAccessPageRBAC = {
  pageID: 'f4f3877a6e58309fb11315d9e0c077e0',
  elementID: {
    ViewList: 'a7d5e1d29bb052d0a457988beee4eace',
    AddNewPage: 'd7c36094263d3b14849a10cbce6dc64e',
  },
} as const

export const useRBACIntoolsAccessPagePage = createUseRBAC(IntoolsAccessPageRBAC.elementID)

export type UseRBACIntoolsAccessPagePageType = ReturnType<typeof useRBACIntoolsAccessPagePage>
